export default {
  surtitle: {
    id: 'bo_sellers_customer_care_open_tasks_technical_issue_block_surtitle',
    defaultMessage: 'Something went wrong in our end.',
  },
  buttonLabel: {
    id: 'bo_sellers_customer_care_open_tasks_technical_issue_block_button_label',
    defaultMessage: 'Try again',
  },
}
